"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementDimensions;
/* finds and returns a target elements height and width including padding and border, but not margins */
/* must pass in an element reference */
function getElementDimensions(elem) {
  let d = {
    w: 0,
    h: 0
  };
  d.w = elem.offsetWidth;
  d.h = elem.offsetHeight;
  return d;
}